var React = require('react');

function ArtBox (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"236","height":"111","fill":"white"}));
}

ArtBox.defaultProps = {"fill":"none"};

module.exports = ArtBox;

ArtBox.default = ArtBox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/art-box.svg
// module id = 1031
// module chunks = 0